import { useEffect, useState } from 'react';
import {
  SHOW_THROUGH_DEFAULT,
  subscribeHoneycombSurfaceImages,
} from '../services/honeycombSurfaceImageCloud';
import { subscribeNavigatorMusicArtwork } from '../services/navigatorMusicNowPlaying';

export function useHoneycombLiveSurface(uid, appearance) {
  const [musicUrl, setMusicUrl] = useState(null);
  const [docs, setDocs] = useState([]);
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    if (!uid) {
      setMusicUrl(null);
      return undefined;
    }
    return subscribeNavigatorMusicArtwork(uid, setMusicUrl);
  }, [uid]);

  useEffect(() => {
    if (!uid) {
      setDocs([]);
      return undefined;
    }
    return subscribeHoneycombSurfaceImages(uid, setDocs);
  }, [uid]);

  const cloud = docs.find((d) => d.appearance === appearance && d.blob);

  useEffect(() => {
    if (!cloud?.blob) {
      setObjectUrl(null);
      return undefined;
    }
    const url = URL.createObjectURL(cloud.blob);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [cloud?.blob, appearance]);

  return {
    url: musicUrl || objectUrl,
    showThrough: cloud?.showThrough ?? SHOW_THROUGH_DEFAULT,
  };
}
